import React, { useState } from 'react';
import { Button, Tooltip } from '@mui/material';
import { useDispatch } from 'react-redux';
import { ConfirmDialog } from '@/components/dialogs/ConfirmDialog';
import { showToast } from '@/features/toast/toastSlice';
import { useBatchResetFormConfigMutation } from '@/features/config/configApi';
import { SCOPES } from '@/features/config/scopes';

/**
 * Resets the ticked rows that come from one of the user's broker groups, after they confirm:
 * those groups' configs are deleted, so the fields follow the ledger or default again. Ticked
 * Ledger and Default rows are left alone. Shown only when a ticked row can be reset.
 */
const ResetFormConfigButton = ({ configs, configType, disabled }) => {
	const dispatch = useDispatch();
	const [isConfirmOpen, setIsConfirmOpen] = useState(false);
	const [batchResetFormConfig] = useBatchResetFormConfigMutation();

	const docIds = configs
		.filter((config) => config.scope === SCOPES.BROKER_GROUP)
		.map((config) => config.id);
	if (!docIds.length) return null;

	const skipped = configs.length - docIds.length;

	const handleReset = async () => {
		const result = await batchResetFormConfig({ docIds, configType });
		setIsConfirmOpen(false);
		if (result.error) {
			dispatch(
				showToast({ message: "Couldn't reset the config. Please try again.", error: true }),
			);
			return;
		}
		dispatch(showToast({ message: 'Reset the config', success: true }));
	};

	return (
		<>
			<Tooltip title='Follow the ledger or default again'>
				<span>
					<Button
						variant='table_actions'
						disabled={disabled}
						onClick={() => setIsConfirmOpen(true)}
					>
						{`Reset to default (${docIds.length})`}
					</Button>
				</span>
			</Tooltip>
			<ConfirmDialog
				openDialog={isConfirmOpen}
				handleClose={() => setIsConfirmOpen(false)}
				handleConfirm={handleReset}
				title={`Reset ${docIds.length} field${docIds.length === 1 ? '' : 's'}?`}
				content={`These fields will follow your ledger or the default again, and your group's settings for them are deleted. Groups these rows are shared with lose them too.${skipped ? ` ${skipped} ticked field${skipped === 1 ? ' already follows' : 's already follow'} the ledger or default and won't change.` : ''}`}
				confirmText='Reset'
			/>
		</>
	);
};

export default ResetFormConfigButton;
